import React, { FC, memo, useEffect } from 'react'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import Player from '@ucheba/ui/components/Player/desktop/Player'
import IconClose from '../assets/icon__close.svg'
import { IVideoPlayerProps } from '../types'

interface IBlockProps {
  open: boolean
}

const Block = styled.div<IBlockProps>`
  display: ${(props) => (props.open ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: black;
  z-index: 10;
`

const Wrap = styled.div`
  display: flex;
  justify-content: center;
  height: 100%;
  position: relative;
  width: 100%;
`

const Header = styled.div`
  top: 8px;
  right: 8px;
  position: absolute;
  height: 40px;
  width: 40px;
  background-color: ${sv.color.white9};
  z-index: 15;
  transition: 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: ${sv.color.white50};
  cursor: pointer;

  :hover {
    background-color: ${sv.color.white50};
    color: ${sv.color.black};
  }
`

const Icon = styled(IconClose)`
  color: inherit;
  width: 30px !important;
  height: 30px !important;
`

const VideoPlayer: FC<IVideoPlayerProps> = (props) => {
  const { open, onClose, sources, autoplay = false } = props

  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    }

    if (!open && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = 'auto'
    }
  }, [open])

  if (!open) return null

  return (
    <Block open={open}>
      <Wrap>
        <Header onClick={() => onClose()}>
          <Icon />
        </Header>

        <Player
          source={{
            type: 'video',
            title: '',
            sources,
          }}
          options={{
            autoplay,
          }}
        />
      </Wrap>
    </Block>
  )
}

export default memo(VideoPlayer)
